import AboutHeader from './Header.vue';
import AboutContent from './Content.vue';
import WebsiteFooter from '../WebsiteFooter.vue';
import Footer from '@/components/Footer/Footer.vue';

export default {
  name: 'About',
  components: { WebsiteFooter, AboutContent, AboutHeader, Footer },
  data: () => ({}),
};
